import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./Project.scss";
import Tilt from 'react-parallax-tilt'
import {
  featuredProject,
  webProject,

} from '../../data';
import ProjectList from "./ProjectList/ProjectList";
export const MyComponent = ({ isVisible }) => (
  <motion.div animate={{ opacity: isVisible ? 1 : 0 }} />
)
const scaleVarience={
whileInView:{
  scale:[0,1],
  opacity:[0,1],
  transition:{
    duration:0.5,
    ease:'easeInOut'
  },

},
};
export default function Project() {
  const [selected, setSelected] = useState("featured");
  const [data, setData] = useState([]);
  const list = [
    {
      id: "featured",
      title: "WEB DEVELOPMENT PROJECT",
    },
    {
      id: "web",
      title: "DATA ANALYTICS PROJECT",
    },
   
  ];

  useEffect(() => {
    switch (selected) {
      case "featured":
        setData(featuredProject);
        break;
      case "web":
        setData(webProject);
        break;
   
      default:
        setData(featuredProject);
    }
  }, [selected]);

  return (
    <motion.div
             varience={scaleVarience}
             whileInView={scaleVarience.whileInView}
             >
    <div className="Project" id="project">
      
      <h1>My Project Profile</h1>
      <ul>
        {list.map((item) => (
          <ProjectList
            title={item.title}
            active={selected === item.id}
            setSelected={setSelected}
            id={item.id}
          />
        ))}
      </ul>
      
      <div className="container">
        {data.map((d) => (
          <Tilt>
          <div className="item">
            <img
              src={d.img}
              alt=""
            />
            <h3>{d.title}</h3>
          </div>
          </Tilt>
        ))}
      </div>
      
    </div>
    </motion.div>
  );
}
